module.exports = __webpack_public_path__ + "media/images/flags/16/Myanmar-f2ffc342d396a756ecc9c7dadfb2e10e.png";